import { render } from "./AssTeacherMaster.vue?vue&type=template&id=120c6bd1&scoped=true"
import script from "./AssTeacherMaster.vue?vue&type=script&lang=js"
export * from "./AssTeacherMaster.vue?vue&type=script&lang=js"

import "./AssTeacherMaster.vue?vue&type=style&index=0&id=120c6bd1&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukataa APP-Admin\\Edukatta_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120c6bd1"]])

export default __exports__